import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Progress } from '@h3/antd-vue';
import { listApi } from '@cloudpivot/api';
let DataImporting = class DataImporting extends Vue {
    constructor() {
        super(...arguments);
        this.interval = null;
    }
    mounted() {
        this.interval = setInterval(() => {
            this.getImportProgress();
        }, 5000);
        //设置定时任务5分钟;
        if (this.interval) {
            setTimeout(() => {
                clearInterval(this.interval);
                this.$message.error('连接超时');
            }, 300000);
        }
    }
    getImportProgress() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield listApi.getImportingProgress();
            if (res.errcode === 0) {
                clearInterval(this.interval);
                this.$emit('importEnd', res.data);
            }
        });
    }
    destroyed() {
        clearInterval(this.interval);
    }
};
tslib_1.__decorate([
    Prop({
        type: Number
    })
], DataImporting.prototype, "percent", void 0);
DataImporting = tslib_1.__decorate([
    Component({
        name: 'data-importing',
        components: {
            AProgress: Progress
        }
    })
], DataImporting);
export default DataImporting;
